import { IotError } from "@core/domain/errors/iot.error.ts";

export class HttpRejectedRequestError extends IotError {
    constructor(message: string) {
        super(message);

        Object.setPrototypeOf(this, HttpRejectedRequestError.prototype);
    }
}
